import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, setGroupsAction } from '../../reducers/actions';
import { GroupService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.GET_GROUPS),
    switchMap(action =>
      GroupService.getBySiteId(action.siteId, store).pipe(
        map(data => setGroupsAction(data)),
        catchError(retryAuthentication(action$, 'epics/groups/getGroups'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/groups/getGroups.js